const _import = require('./_import_' + process.env.NODE_ENV)
import i18n from '@/i18n'

function getChild({ type, component }) {
  return {
    path: type,
    name: type,
    component: component,
    meta: { title: i18n.t(`sideBar.systemManage.${type}`), icon: 'el-icon-s-management', noCache: true }
  }
}

function getChildList(list) {
  return list.map(v => {
    return getChild(v)
  })
}
export default {
  path: '/systemManage',
  component: _import('Container'),
  name: 'systemManage',
  redirect: '/systemManage/oplog',
  meta: { title: i18n.t('sideBar.systemManageTitle'), icon: 'el-icon-folder-opened', noCache: true },
  children: getChildList([
    { type: 'oplog', component: _import('systemManage/oplog/index') }
  ])
}



// WEBPACK FOOTER //
// ./src/router/systemManage.js